export default function TopBar() {
  return (
    <div className="w-full bg-primary-600 text-background-50">
      <div className="mx-auto flex h-9 max-w-[1440px] items-center justify-between px-4 text-xs md:px-6">
        <div className="flex items-center gap-2">
          <span className="flex h-1.5 w-1.5 animate-pulse items-center justify-center rounded-full bg-background-50" />
          <span className="font-label tracking-wide">51cg5 实时热度实验室 · 数据每 5 分钟刷新</span>
        </div>
        <div className="hidden items-center gap-5 font-label md:flex">
          <a href="#ranking" className="cursor-pointer transition-colors hover:text-primary-100">
            热度榜单
          </a>
          <a href="#resources" className="cursor-pointer transition-colors hover:text-primary-100">
            资源入口
          </a>
          <button type="button" className="flex cursor-pointer items-center gap-1 transition-colors hover:text-primary-100">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-bookmark-line"></i>
            </span>
            加入收藏
          </button>
        </div>
      </div>
    </div>
  );
}